<template>
    <div class="separator" :class="paddingClass + ' ' + marginClass + ' ' + colClass">
        <hr v-if="withHr">
    </div>
</template>

<script>
    export default {
        name: "Spacer",
        props: {
            paddingClass: {
                type: String,
                required: false,
                default: "py-3"
            },
            marginClass: {
                type: String,
                required: false,
                default: "my-3"
            },
            colClass: {
                type: String,
                required: false,
                default: "col-12"
            },
            withHr: {
                type: Boolean,
                required: false,
                default: true
            }
        }
    }
</script>

<style scoped>

</style>